



// import React, { useState, useRef, useEffect } from "react";
// import styles from "../../assets/scss/WebHomePagesscss/Features.module.scss";
// import { motion, AnimatePresence } from "framer-motion";
// import banner1 from "../../assets/images/BannerFlow1.jpg";
// import banner2 from "../../assets/images/banner2.jpg";
// import banner3 from "../../assets/images/banner3.jpg";

// const images = [banner1, banner2, banner3];



// const textSlides = [
//   {
//     title: "CropWork makes every connections count 🥦",
//     line1: "We bridge the gap between wholesalers, farmers and retailers ",
//     line2: "Ensuring every connection leads to fresher produce, fairer trade, and a more efficient supply chain.",
//   },
//   {
//     title: "CropWork makes every connections count 🌾",
//     line1: "Where wholesalers meet their farmers, retailers and customers.",
//     line2: "",
//   },
//   {
//     title: "CropWork makes every connections count 🌱",
//     line1: "A platform for farmers to connect within their community, gain market insights, and share posts and list that help everyone grow.",
//     line2: "",
//   },
//   {
//     title: "CropWork makes every connections count 🧺",
//     line1: "Empowering retailers and customers with a smooth ordering and billing experience that saves time and builds trust.",
//     line2: "",
//   },
//   {
//     title: "Features ⚙️",
//     line1: "Eassy Invoice, Automated Inventory, Efficient Order and Quick billing , wholesome ledger.",
//     line2: "",
//   },
// ];

// const Features = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [textIndex, setTextIndex] = useState(0);
//   const startX = useRef(0);
//   const endX = useRef(0);

//   // ✅ Auto-scroll text every 4 seconds
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setTextIndex((prev) => (prev + 1) % textSlides.length);
//     }, 4000);
//     return () => clearInterval(interval);
//   }, []);

//   // ✅ Handle swipe for image carousel only
//   const handleTouchStart = (e) => {
//     startX.current = e.touches[0].clientX;
//   };

//   const handleTouchMove = (e) => {
//     endX.current = e.touches[0].clientX;
//   };

//   const handleTouchEnd = () => {
//     const diff = startX.current - endX.current;
//     if (diff > 50) {
//       setCurrentIndex((prev) => (prev + 1) % images.length);
//     } else if (diff < -50) {
//       setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
//     }
//   };

//   return (
//     <div className={styles.featuresSection}>
//       {/* ✅ Auto-Scroll Text Carousel */}
//       <AnimatePresence mode="wait">
//         <motion.div
//           key={textSlides[textIndex].title}
//           initial={{ opacity: 0, y: -20 }}
//           animate={{ opacity: 1, y: 0 }}
//           exit={{ opacity: 0, y: 20 }}
//           transition={{ duration: 0.6 }}
//         >
//           <motion.h2 className={styles.heading}>
//             {textSlides[textIndex].title}
//           </motion.h2>
//           <p className={styles.subheading}>{textSlides[textIndex].line1}</p>
//           <p className={styles.subheading}>{textSlides[textIndex].line2}</p>
//         </motion.div>
//       </AnimatePresence>

//       {/* ✅ Image Swipe Carousel */}
//       <div
//         className={styles.carouselContainer}
//         onTouchStart={handleTouchStart}
//         onTouchMove={handleTouchMove}
//         onTouchEnd={handleTouchEnd}
//       >
//         <AnimatePresence mode="wait">
//           <motion.img
//             key={images[currentIndex]}
//             src={images[currentIndex]}
//             alt="Vegetable Banner"
//             className={styles.bannerImage}
//             initial={{ opacity: 0, x: 50 }}
//             animate={{ opacity: 1, x: 0 }}
//             exit={{ opacity: 0, x: -50 }}
//             transition={{ duration: 0.6 }}
//           />
//         </AnimatePresence>
//       </div>

//       {/* ✅ Dots for Image Carousel */}
//       <div className={styles.dotsContainer}>
//         {images.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrentIndex(index)}
//             className={`${styles.dot} ${
//               index === currentIndex ? styles.activeDot : ""
//             }`}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Features;


import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import styles from "../../assets/scss/WebHomePagesscss/Features.module.scss";
import { motion, AnimatePresence } from "framer-motion";
import { BaseURL } from "../../lib/api";
import banner1 from "../../assets/images/BannerFlow1.jpg";
import banner2 from "../../assets/images/banner2.jpg";
import banner3 from "../../assets/images/banner3.jpg";

const fallbackImages = [banner1, banner2, banner3];

const textSlides = [
  {
    title: "We maximize the value of your connection 🥦",
    line1: "We bridge the gap between wholesalers, farmers, and retailers,",
    line2: "Ensuring every connection leads to fresher produce, fairer trade, and a more efficient supply chain.",
  },
  {
    title: "We maximize the value of your connection 🌾",
    line1: "Where wholesalers meet their farmers, retailers and customers.",
    line2: "",
  },
  {
    title: "We maximize the value of your connection 🌱",
    line1: "A platform for farmers to connect within their community, gain market insights, and share posts that help everyone grow.",
    line2: "",
  },
  {
    title: "We maximize the value of your connection 🧺",
    line1: "Empowering retailers and customers with a smooth ordering and billing experience that saves time and builds trust.",
    line2: "",
  },
  {
    title: "Features ⚙️",
    line1: "Easy Invoice, Automated Inventory, Efficient Orders, and Quick Billing.",
    line2: "",
  },
];

const Features = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [textIndex, setTextIndex] = useState(0);
  const [bannerImages, setBannerImages] = useState(fallbackImages);
  const startX = useRef(0);
  const endX = useRef(0);

  // ✅ Fetch banner images from API
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${BaseURL}/dashboard/getLandingBanners`);
        const apiImages = response.data?.result?.landingPageImages || [];
        if (apiImages.length > 0) {
          const fullUrls = apiImages.map((img) =>
            img.startsWith("http") ? img : `${BaseURL}/${img}`
          );
          setBannerImages(fullUrls);
        }
      } catch (error) {
        console.error("Failed to fetch banners:", error);
        // Fallback to default images
        setBannerImages(fallbackImages);
      }
    };

    fetchBanners();
  }, []);

  // ✅ Auto-scroll text every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex((prev) => (prev + 1) % textSlides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  // ✅ Handle swipe gestures
  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    endX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const diff = startX.current - endX.current;
    if (diff > 50) {
      setCurrentIndex((prev) => (prev + 1) % bannerImages.length);
    } else if (diff < -50) {
      setCurrentIndex((prev) => (prev - 1 + bannerImages.length) % bannerImages.length);
    }
  };

  return (
    <div className={styles.featuresSection}>
      {/* ✅ Auto-Scroll Text Carousel */}
      <div className={styles.textCarousel}>
          <AnimatePresence mode="wait">
        <motion.div
          key={textSlides[textIndex].title}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
        >
          <motion.h2 className={styles.heading}>
            {textSlides[textIndex].title}
          </motion.h2>
          <p className={styles.subheading}>{textSlides[textIndex].line1}</p>
          <p className={styles.subheading}>{textSlides[textIndex].line2}</p>
        </motion.div>
      </AnimatePresence>
      </div>
    

      {/* ✅ Image Swipe Carousel */}
      <div
        className={styles.carouselContainer}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <AnimatePresence mode="wait">
          <motion.img
            key={bannerImages[currentIndex]}
            src={bannerImages[currentIndex]}
            alt="Home Banner"
            className={styles.bannerImage}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.6 }}
          />
        </AnimatePresence>
      </div>

      {/* ✅ Dots for Image Carousel */}
      <div className={styles.dotsContainer}>
        {bannerImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`${styles.dot} ${
              index === currentIndex ? styles.activeDot : ""
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default Features;





